import { useEffect, useState } from "react";
import { api } from "./api";
import { PAGE_TEXTS } from "../data/pageTexts";

const cache = {};
const load = (page) => {
  if (!cache[page]) cache[page] = api.get("/site-texts", { params: { page } }).then((r) => r.data || []).catch(() => []);
  return cache[page];
};
export const refreshSiteTexts = (page) => { delete cache[page]; };

// SEO-titel en metabeschrijving van een pagina uit PAGE_TEXTS, met aanpassing uit Beheer → Teksten.
export const usePageSeo = (page) => {
  const seo = useSiteTexts(page)(PAGE_TEXTS[page].blocks.seo);
  return { title: seo.title, description: seo.body };
};

// Standaardteksten staan in de code; aanpassingen uit Beheer → Teksten overschrijven titel en/of tekst per blok.
export const useSiteTexts = (page) => {
  const [list, setList] = useState([]);
  useEffect(() => {
    let on = true;
    load(page).then((l) => on && setList(l));
    return () => { on = false; };
  }, [page]);
  return (block) => {
    const o = list.find((x) => x.key === `${page}.${block.key}`);
    return o ? { ...block, title: o.title || block.title, body: o.body || block.body } : block;
  };
};
